import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=20ab6322&scoped=true&"
import script from "./retrieve.vue?vue&type=script&lang=js&"
export * from "./retrieve.vue?vue&type=script&lang=js&"
import style0 from "./retrieve.vue?vue&type=style&index=0&id=20ab6322&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab6322",
  null
  
)

export default component.exports